import React, { memo } from 'react'

import * as S from './styled'

type EmptyStateProps = {
  searchValue: string
}

export const EmptyState = memo(({ searchValue }: EmptyStateProps) => (
  <S.Container>
    <S.Content>
      <span>No results found for{` `}</span>
      <span>
        '<strong>{searchValue}</strong>'.
      </span>
    </S.Content>
  </S.Container>
))
